export default {
  nav: {
    home: 'ホーム',
    aboutUs: '会社概要',
    facilities: '設備',
    certification: '認証',
    portofolio: 'ポートフォリオ',
    service: 'サービス',
    career: '採用情報',
    newsBlog: 'ニュース・ブログ',
    factoryTour: '工場見学',
    seminar: 'セミナー',
    contactUs: 'お問い合わせ',
  },
  footer: {
    copyright: 'PT. TOKKI ENGINEERING AND FABRICATION',
  },
  languageSwitcher: {
    label: '言語',
    id: 'インドネシア語',
    en: '英語',
    ja: '日本語',
  },
  offices: {
    motoStartWithTokki: 'TOKKIとともに',
    mainOfficeFactory: '本社・第一工場',
    secondOfficeFactory: '第二オフィス・工場',
    thirdOfficeFactory: '第三オフィス・工場',
    fourthMarketingOffice: '第四駐在員事務所',
    readMore: '続きを読む',
    ourHappyClient: 'お客様の声',
    majorCustomerIn: '主要顧客：',
    productServices: '製品・サービス',
  },
};
